(function () {
  function installSekMoneyFormatFix() {
    if (!window.theme || !theme.Currency || typeof theme.Currency.formatMoney !== 'function') {
      return false;
    }

    if (theme.Currency._sekSpaceFormatPatched) {
      return true;
    }

    var originalFormatMoney = theme.Currency.formatMoney;

    theme.Currency.formatMoney = function (cents, format) {
      format = format || (theme.strings && theme.strings.moneyFormat) || '';

      if (format.indexOf('{{amount_with_space_separator}}') !== -1) {
        var numericCents = Number(cents);

        if (!isFinite(numericCents)) {
          return originalFormatMoney(cents, format);
        }

        var parts = (numericCents / 100).toFixed(2).split('.');
        var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        var value = whole + ',' + parts[1];

        return format.replace('{{amount_with_space_separator}}', value);
      }

      return originalFormatMoney(cents, format);
    };

    theme.Currency._sekSpaceFormatPatched = true;
    return true;
  }

  if (!installSekMoneyFormatFix()) {
    document.addEventListener('DOMContentLoaded', installSekMoneyFormatFix);
  }
})();